import { IndicatorName } from '@/api/rest/resources/types/fact';
import { INDICATOR } from '@/api/rest/resources/types/IndicatorProduct';

import { useIndicatorProduct } from './useIndicatorProduct';

const FACT_NAMES = {
  CECIL: {
    total: {
      graph: IndicatorName.above_ground_carbon_historic_total_graph,
      // benchmark: R1FactType.above_ground_carbon_total_benchmark_graph,
      latestAnalysis: IndicatorName.above_ground_carbon_total,
      oneYearUplift: IndicatorName.above_ground_carbon_total_previous_1y_uplift,
      oneYearPctChange: IndicatorName.above_ground_carbon_total_previous_1y_pct_change,
    },
    perHa: {
      graph: IndicatorName.above_ground_carbon_historic_per_ha_graph,
      // benchmark: R1FactType.above_ground_carbon_per_ha_benchmark_graph,
      latestAnalysis: IndicatorName.above_ground_carbon_per_ha,
      oneYearUplift: IndicatorName.above_ground_carbon_per_ha_previous_1y_uplift,
      oneYearPctChange: IndicatorName.above_ground_carbon_per_ha_previous_1y_pct_change,
    },
  },
  ESA: {
    total: {
      graph: IndicatorName.esa_above_ground_carbon_historic_total_graph,
      // benchmark: R1FactType.esa_above_ground_carbon_total_benchmark_graph,
      latestAnalysis: IndicatorName.esa_above_ground_carbon_total,
      oneYearUplift: IndicatorName.esa_above_ground_carbon_total_previous_1y_uplift,
      oneYearPctChange: IndicatorName.esa_above_ground_carbon_total_previous_1y_pct_change,
    },
    perHa: {
      graph: IndicatorName.esa_above_ground_carbon_historic_per_ha_graph,
      // benchmark: R1FactType.esa_above_ground_carbon_per_ha_benchmark_graph,
      latestAnalysis: IndicatorName.esa_above_ground_carbon_per_ha,
      oneYearUplift: IndicatorName.esa_above_ground_carbon_per_ha_previous_1y_uplift,
      oneYearPctChange: IndicatorName.esa_above_ground_carbon_per_ha_previous_1y_pct_change,
    },
  },
};

export const useAboveGroundCarbonFacts = () => {
  const purchasedIndicatorProducts =
    useIndicatorProduct({
      purchased: true,
      visible_for_customer: true,
    }).data ?? [];
  const hasCecilIP = purchasedIndicatorProducts.some(
    (ip) => INDICATOR.ABOVE_GROUND_CARBON === ip.name && ip.purchased_at,
  );

  const hasEsaIP = purchasedIndicatorProducts.some(
    (ip) => INDICATOR.ESA_ABOVE_GROUND_CARBON === ip.name && ip.purchased_at,
  );

  if (hasEsaIP && hasCecilIP) {
    throw new Error('Multiple above ground carbon indicator products purchased, unable to determine data source');
  }

  if (hasEsaIP) {
    return FACT_NAMES.ESA;
  }

  if (!hasCecilIP && !hasEsaIP) {
    return undefined;
  }

  return FACT_NAMES.CECIL;
};
